// Product wishlist hearts (product page + featured product), via the Swym list API. A heart shows as saved
// when any variant of its product is in the wishlist, so it agrees with the collection-card hearts;
// saving adds the variant currently selected.
(() => {
  const LIST_NAME = 'My Wishlist';
  const hearts = [];

  const setupHeart = (button) => {
    const productId = Number(button.dataset.productId);
    const productUrl = button.dataset.productUrl;
    let swat = null;
    let list = null;
    let busy = false;

    const selectedVariantId = () => {
      const section = button.closest('[js-product-section]') || document;
      const input = section.querySelector('form[action*="/cart/add"] [name="id"]');
      return Number(input?.value || button.dataset.variantId);
    };

    const savedItems = () => (list?.listcontents || []).filter((item) => Number(item.empi) === productId);

    const render = () => {
      button.setAttribute('aria-pressed', String(savedItems().length > 0));
    };

    const refresh = (then) => {
      swat.fetchLists({
        callbackFn: (lists) => {
          list = lists.find((l) => l.lname === LIST_NAME) || lists[0] || null;
          render();
          if (then) then();
        },
        errorFn: () => then && then(),
      });
    };

    const withList = (fn, fail) => {
      if (list) return fn(list);
      swat.createList({ lname: LIST_NAME }, (created) => {
        list = { ...created, listcontents: [] };
        fn(list);
      }, fail);
    };

    button.addEventListener('click', () => {
      if (!swat || busy) return;
      busy = true;
      const done = () => refresh(() => { busy = false; });
      const saved = savedItems();

      if (saved.length) {
        let pending = saved.length;
        saved.forEach((item) => {
          const step = () => { pending -= 1; if (!pending) done(); };
          swat.deleteFromList(list.lid, { epi: item.epi, empi: item.empi, du: item.du }, step, step);
        });
      } else {
        withList((l) => {
          swat.addToList(l.lid, { epi: selectedVariantId(), empi: productId, du: productUrl }, done, done);
        }, done);
      }
    });

    hearts.push({ connect: (s) => { swat = s; refresh(); }, refresh: () => swat && refresh() });
  };

  document.querySelectorAll('[js-product-wishlist]').forEach(setupHeart);
  if (!hearts.length) return;

  const init = (s) => {
    hearts.forEach((heart) => heart.connect(s));
    // Keep in sync when the drawer or a card heart changes the list
    const events = s.JSEvents || {};
    [events.addedToWishlist, events.removedFromWishlist].filter(Boolean).forEach((evt) => {
      s.evtLayer?.addEventListener?.(evt, () => hearts.forEach((heart) => heart.refresh()));
    });
  };

  if (window._swat?.fetchLists && document.body.classList.contains('swym-ready')) {
    init(window._swat);
  } else {
    (window.SwymCallbacks = window.SwymCallbacks || []).push(init);
  }
})();
